var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddingBottomMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_282)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    transform: "translate(196 98) rotate(180)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 84,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(-90 8 84)",
    fill: "#007FFF",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 84,
    width: 70,
    height: 180,
    rx: 5,
    transform: "rotate(-90 8 84)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.646 76.3536C103.842 76.5488 104.158 76.5488 104.354 76.3536L107.536 73.1716C107.731 72.9763 107.731 72.6597 107.536 72.4645C107.34 72.2692 107.024 72.2692 106.828 72.4645L104 75.2929L101.172 72.4645C100.976 72.2692 100.66 72.2692 100.464 72.4645C100.269 72.6597 100.269 72.9763 100.464 73.1716L103.646 76.3536ZM104.354 55.6464C104.158 55.4512 103.842 55.4512 103.646 55.6464L100.464 58.8284C100.269 59.0237 100.269 59.3403 100.464 59.5355C100.66 59.7308 100.976 59.7308 101.172 59.5355L104 56.7071L106.828 59.5355C107.024 59.7308 107.34 59.7308 107.536 59.5355C107.731 59.3403 107.731 59.0237 107.536 58.8284L104.354 55.6464ZM104.5 76L104.5 56L103.5 56L103.5 76L104.5 76Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 48L8 19C8 16.2386 10.2386 14 13 14L183 14C185.761 14 188 16.2386 188 19L188 48L8 48Z",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.543 17.1182C187.836 17.6907 188 18.3282 188 19C188 18.3219 187.877 17.6724 187.653 17.0727L187.543 17.1182ZM184.747 14.7823L185.025 14.1124C184.409 13.7935 183.725 13.5877 183 13.5224C182.835 13.5076 182.669 13.5 182.5 13.5L180.976 13.5L180.976 14.5L183 14.5C183.614 14.5 184.203 14.5997 184.747 14.7823ZM176.929 14.5L176.929 13.5L172.881 13.5L172.881 14.5L176.929 14.5ZM168.833 14.5L168.833 13.5L164.786 13.5L164.786 14.5L168.833 14.5ZM160.738 14.5L160.738 13.5L156.69 13.5L156.69 14.5L160.738 14.5ZM152.643 14.5L152.643 13.5L148.595 13.5L148.595 14.5L152.643 14.5ZM144.548 14.5L144.548 13.5L140.5 13.5L140.5 14.5L144.548 14.5ZM136.452 14.5L136.452 13.5L132.405 13.5L132.405 14.5L136.452 14.5ZM128.357 14.5L128.357 13.5L124.31 13.5L124.31 14.5L128.357 14.5ZM120.262 14.5L120.262 13.5L116.214 13.5L116.214 14.5L120.262 14.5ZM112.167 14.5L112.167 13.5L108.119 13.5L108.119 14.5L112.167 14.5ZM104.071 14.5L104.071 13.5L100.024 13.5L100.024 14.5L104.071 14.5ZM95.9762 14.5L95.9762 13.5L91.9285 13.5L91.9285 14.5L95.9762 14.5ZM87.8809 14.5L87.8809 13.5L83.8333 13.5L83.8333 14.5L87.8809 14.5ZM79.7857 14.5L79.7857 13.5L75.7381 13.5L75.7381 14.5L79.7857 14.5ZM71.6904 14.5L71.6904 13.5L67.6428 13.5L67.6428 14.5L71.6904 14.5ZM63.5952 14.5L63.5952 13.5L59.5476 13.5L59.5476 14.5L63.5952 14.5ZM55.4999 14.5L55.4999 13.5L51.4523 13.5L51.4523 14.5L55.4999 14.5ZM47.4047 14.5L47.4047 13.5L43.3571 13.5L43.3571 14.5L47.4047 14.5ZM39.3095 14.5L39.3095 13.5L35.2618 13.5L35.2618 14.5L39.3095 14.5ZM31.2142 14.5L31.2142 13.5L27.1666 13.5L27.1666 14.5L31.2142 14.5ZM23.119 14.5L23.119 13.5L19.0714 13.5L19.0714 14.5L23.119 14.5ZM15.0237 14.5L15.0237 13.5L13.5 13.5C13.3315 13.5 13.1647 13.5076 13 13.5224C12.2754 13.5877 11.5914 13.7935 10.9753 14.1124L11.2531 14.7823C11.7969 14.5998 12.3855 14.5 13 14.5L15.0237 14.5ZM8.34715 17.0727C8.12271 17.6725 8 18.3219 8 19C8 18.3282 8.16358 17.6907 8.45685 17.1182L8.34715 17.0727ZM8 47.5L8 48L8 48.5L9.95652 48.5L9.95652 47.5L8 47.5ZM13.8696 47.5L13.8696 48.5L17.7826 48.5L17.7826 47.5L13.8696 47.5ZM21.6957 47.5L21.6957 48.5L25.6087 48.5L25.6087 47.5L21.6957 47.5ZM29.5217 47.5L29.5217 48.5L33.4348 48.5L33.4348 47.5L29.5217 47.5ZM37.3478 47.5L37.3478 48.5L41.2609 48.5L41.2609 47.5L37.3478 47.5ZM45.1739 47.5L45.1739 48.5L49.087 48.5L49.087 47.5L45.1739 47.5ZM53 47.5L53 48.5L56.913 48.5L56.913 47.5L53 47.5ZM60.8261 47.5L60.8261 48.5L64.7391 48.5L64.7391 47.5L60.8261 47.5ZM68.6522 47.5L68.6522 48.5L72.5652 48.5L72.5652 47.5L68.6522 47.5ZM76.4783 47.5L76.4783 48.5L80.3913 48.5L80.3913 47.5L76.4783 47.5ZM84.3043 47.5L84.3043 48.5L88.2174 48.5L88.2174 47.5L84.3043 47.5ZM92.1304 47.5L92.1304 48.5L96.0435 48.5L96.0435 47.5L92.1304 47.5ZM99.9565 47.5L99.9565 48.5L103.87 48.5L103.87 47.5L99.9565 47.5ZM107.783 47.5L107.783 48.5L111.696 48.5L111.696 47.5L107.783 47.5ZM115.609 47.5L115.609 48.5L119.522 48.5L119.522 47.5L115.609 47.5ZM123.435 47.5L123.435 48.5L127.348 48.5L127.348 47.5L123.435 47.5ZM131.261 47.5L131.261 48.5L135.174 48.5L135.174 47.5L131.261 47.5ZM139.087 47.5L139.087 48.5L143 48.5L143 47.5L139.087 47.5ZM146.913 47.5L146.913 48.5L150.826 48.5L150.826 47.5L146.913 47.5ZM154.739 47.5L154.739 48.5L158.652 48.5L158.652 47.5L154.739 47.5ZM162.565 47.5L162.565 48.5L166.478 48.5L166.478 47.5L162.565 47.5ZM170.391 47.5L170.391 48.5L174.304 48.5L174.304 47.5L170.391 47.5ZM178.217 47.5L178.217 48.5L182.13 48.5L182.13 47.5L178.217 47.5ZM186.043 47.5L186.043 48.5L188 48.5L188 48L188 47.5L186.043 47.5Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 150,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 150)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 150,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 150)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 6,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 6)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 6,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 6)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white",
    transform: "translate(196 98) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddingBottomMd);
export default __webpack_public_path__ + "static/media/padding_bottom_md.18ba7be7c768307924c36b73b519a5ee.svg";
export { ForwardRef as ReactComponent };